interface Area {
  name: string;
  description: string;
  properties: number;
  image: string;
  alt: string;
  popular: number;
}
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-areas',
  templateUrl: './areas.component.html',
  styleUrls: ['./areas.component.css']
})
export class AreasComponent {
  searchTerm: string = '';
  sortBy: string = 'properties';

  areas: Area[] = [
    {
      name: 'Genting Highlands',
      description:
        'Cool highland living with scenic surroundings and convenient access to Kuala Lumpur.',
      properties: 180,
      image:
        'assets/images/areas/genting-highlands.jpg',
      alt:
        'Properties and homes for rent in Genting Highlands',
      popular: 9
    },
    {
      name: 'Cheras',
      description:
        'Affordable living with excellent amenities, transport links and everyday convenience.',
      properties: 170,
      image:
        'assets/images/areas/cheras.jpg',
      alt:
        'Properties and rooms for rent in Cheras Kuala Lumpur',
      popular: 8
    },
    {
      name: 'Jalan Kuchai Lama',
      description:
        'Convenient city-fringe neighbourhood with excellent connectivity and amenities.',
      properties: 160,
      image:
        'assets/images/areas/jalan-kuchai-lama.jpg',
      alt:
        'Properties and rooms for rent in Jalan Kuchai Lama',
      popular: 7
    },
    {
      name: 'Balakong',
      description:
        'Practical and affordable neighbourhood with growing residential and commercial options.',
      properties: 145,
      image:
        'assets/images/areas/balakong.jpg',
      alt:
        'Properties and homes for rent in Balakong',
      popular: 6
    },
    {
      name: 'Kajang',
      description:
        'Family-friendly living with modern developments, amenities and convenient connectivity.',
      properties: 135,
      image:
        'assets/images/areas/kajang.jpg',
      alt:
        'Properties and rooms for rent in Kajang',
      popular: 5
    },
    {
      name: 'Kepong',
      description:
        'Spacious living with established communities, parks and excellent everyday facilities.',
      properties: 100,
      image:
        'assets/images/areas/kepong.jpg',
      alt:
        'Properties and rooms for rent in Kepong Kuala Lumpur',
      popular: 4
    },
    {
      name: 'Puchong',
      description:
        'Well-connected suburban living with modern townships, shopping and lifestyle amenities.',
      properties: 125,
      image:
        'assets/images/areas/puchong.jpg',
      alt:
        'Properties and homes for rent in Puchong',
      popular: 3
    },
    {
      name: 'Ampang',
      description:
        'Strategic location with easy access to KL city centre, amenities and public transport.',
      properties: 150,
      image:
        'assets/images/areas/ampang.jpg',
      alt:
        'Properties and rooms for rent in Ampang Kuala Lumpur',
      popular: 2
    },
    {
      name: 'Kuala Lumpur (KL)',
      description:
        'Experience vibrant city living close to business districts, attractions and major transport links.',
      properties: 300,
      image:
        'assets/images/areas/kuala-lumpur.jpg',
      alt:
        'Properties and rooms for rent in Kuala Lumpur KL',
      popular: 10
    }
  ];

  /*
   * =========================================================
   * FILTERED AREAS
   * =========================================================
   *
   * This is the array displayed by the HTML.
   */
  filteredAreas: Area[] = [...this.areas];

  /*
   * =========================================================
   * CONSTRUCTOR
   * =========================================================
   */
  constructor() {
    // Make sure the default sorting is applied
    // when the page first loads.
    this.filterAreas();
  }

  /*
   * =========================================================
   * SEARCH + SORT
   * =========================================================
   */
  filterAreas(): void {
    /*
     * Convert search text to lowercase
     * so searching is case-insensitive.
     */

    const search =
      this.searchTerm
        .trim()
        .toLowerCase();
    /*
     * FILTER
     *
     * Search by area name.
     */
    let results: Area[] = this.areas.filter(
      (area: Area) => {

        return area.name
          .toLowerCase()
          .includes(search);
      }
    );

    /*
     * SORT
     */
    switch (this.sortBy) {
      case 'properties':
        results.sort(
          (a: Area, b: Area) =>
            b.properties - a.properties
        );
        break;		
      case 'name':
        results.sort(
          (a: Area, b: Area) =>
            a.name.localeCompare(b.name)
        );
        break;
      case 'popular':
        results.sort(
          (a: Area, b: Area) =>
            b.popular - a.popular
        );
        break;
    }
    this.filteredAreas = results;
  }

  /*
   * =========================================================
   * CLEAR SEARCH
   * =========================================================
   */
  clearSearch(): void {
    this.searchTerm = '';
    this.filterAreas();
  }

  /*
   * =========================================================
   * WHATSAPP
   * =========================================================
   */
  openWhatsApp(event: Event): void {
    /*
     * Prevent the default <a> behaviour.
     */
    event.preventDefault();
    /*
     * Prevent the child WhatsApp button from
     * triggering the parent area-card click again.
     */
    event.stopPropagation();
    const phoneNumber = '+601114278964';
    const message =
      'Hi, I am interested in finding a property.';
    const whatsappUrl =
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(
      whatsappUrl,
      '_blank',
      'noopener,noreferrer'
    );
  }

  /*
  * =========================================================
  * FAQ
  * =========================================================
  */
 openFaq: number | null = null;
 showAllFaq: boolean = false;
 
 /*
  * =========================================================
  * TOGGLE FAQ
  * =========================================================
  */
 toggleFaq(index: number): void {
   if (this.openFaq === index) {
     this.openFaq = null;
   } else {
     this.openFaq = index;
   }
 }

 /*
  * =========================================================
  * SHOW MORE / SHOW LESS FAQ
  * =========================================================
  */
 toggleAllFaq(): void {
   this.showAllFaq = !this.showAllFaq;
   /*
    * If SHOW LESS is clicked and an FAQ from
    * FAQ 11-50 is open, close it.
    */
   if (
     !this.showAllFaq &&
     this.openFaq !== null &&
     this.openFaq >= 10
   ) {
     this.openFaq = null;
   }
 }
}